module.exports = __webpack_public_path__ + "2fae61f361ef896478bc392ef954ea68.png";